import axios from "axios";
import store from "../store/store";
import { currentLocale } from "../i18n";

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
      Authorization: "Bearer " + store.getState().user.token,
      Accept: "application/json",
      timeout: 1000,
    },
  });

  instance.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.getState().user.token;
    // The language the person reads the site in, for the backend's messages, emails and PDFs.
    config.headers["Accept-Language"] = currentLocale();
    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.href = "/Login";
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const axiosInstance = createAxiosInstance();

export default axiosInstance;
